if (!customElements.get("custom-marquee")) {
  class CustomMarquee extends HTMLElement {
    constructor() {
      super();
      this._initialized = false;
      this._resizeObserver = null;
    }

    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this.setupMarquee();
      this.setupResizeObserver();
    }

    disconnectedCallback() {
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
      }
    }

    setupMarquee() {
      const spans = Array.from(this.querySelectorAll(".marquee-text"));
      if (spans.length === 0) return;

      // Create the scrolling track with duplicated content
      const content = spans.map((span) => span.outerHTML).join("");
      this.innerHTML = `<div class="marquee-track">${content}${content}${content}</div>`;

      this.adjustAnimationSpeed();
    }

    setupResizeObserver() {
      if ("ResizeObserver" in window) {
        this._resizeObserver = new ResizeObserver(() => {
          this.adjustAnimationSpeed();
        });
        this._resizeObserver.observe(this);
      }
    }

    adjustAnimationSpeed() {
      const track = this.querySelector(".marquee-track");
      if (!track) return;

      const containerWidth = this.offsetWidth;
      const contentWidth = track.scrollWidth / 3;

      const baseDuration =
        parseFloat(this.style.getPropertyValue("--duration")) || 3;
      const speedRatio = contentWidth / containerWidth;
      const adjustedDuration = Math.max(baseDuration * speedRatio, 2);

      track.style.animationDuration = `${adjustedDuration}s`;
    }

    // Method to update texts dynamically if needed
    updateTexts(newTexts) {
      if (!Array.isArray(newTexts)) return;

      const content = newTexts
        .map(
          (text) => `<span class="marquee-text">${text.toUpperCase()}</span>`
        )
        .join("");

      this.innerHTML = `<div class="marquee-track">${content}${content}</div>`;
      this.adjustAnimationSpeed();
    }
  }

  customElements.define("custom-marquee", CustomMarquee);
}

// Sticky Header Scroll Detection
(function() {
  const stickyHeader = document.querySelector('.section-header');
  
  if (!stickyHeader) return;
  
  let lastScrollTop = 0;
  let ticking = false;
  
  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // Add 'scrolled' class when scrolled down more than 50px
    if (scrollTop > 50) {
      stickyHeader.classList.add('scrolled');
    } else {
      stickyHeader.classList.remove('scrolled');
    }
    
    lastScrollTop = scrollTop;
    ticking = false;
  }
  
  function requestTick() {
    if (!ticking) {
      window.requestAnimationFrame(handleScroll);
      ticking = true;
    }
  }
  
  // Listen for scroll events with throttling
  window.addEventListener('scroll', requestTick, { passive: true });
  
  // Check initial state
  handleScroll();
})();